module.exports = __webpack_public_path__ + "img/pa.9904c98f.svg";